const DOCUMENT_NAMES = {
  certificate: 'atestado',
  'special-prescription': 'receituario-especial',
  prescription: 'receituario',
  'nota-fiscal': 'nota-fiscal',
  boleto: 'boleto',
  orcamento: 'orcamento',
  'termo-de-adesao': 'termo-de-adesao',
};

export function createDocumentFileName({ documentType, laudoId, link }) {
  const extension = String(link).split('?')[0].toLowerCase().endsWith('.pdf') ? '' : '.pdf';
  const suffix = laudoId ? `-${laudoId}` : '';
  const base = DOCUMENT_NAMES[documentType] ?? documentType ?? 'documento';

  return `${base}${suffix}${extension}`;
}

export function redirectTo(link, options = {}) {
  return window?.ReactNativeWebView?.postMessage(
    JSON.stringify({
      service: true,
      action: options.action,
      openInBrowser: true,
      url: `${link}`,
      filename: options.filename,
      mimeType: options.mimeType,
      documentType: options.documentType,
    })
  );
}

// Baixa/compartilha um documento: aciona o app nativo (downloadFile) quando disponível,
// ou abre numa nova aba no navegador comum.
export function shareDocument(link, { documentType, laudoId, mimeType = 'application/pdf' } = {}) {
  if (!link) return;

  const filename = createDocumentFileName({ documentType, laudoId, link });

  if (window?.ReactNativeWebView?.postMessage) {
    redirectTo(link, { action: 'downloadFile', documentType, filename, mimeType });
    return;
  }

  window?.open(link, '_blank');
}

function blobToDataUrl(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

// Mesma ideia de shareDocument, mas para respostas que já vieram como Blob (ex: nota fiscal).
// Dentro do app nativo, converte pra data URL e aciona o downloadFile; no navegador comum,
// usa o link temporário (mais leve, sem precisar converter pra base64).
export async function shareBlobDocument(blob, { documentType, laudoId, filename: explicitFilename } = {}) {
  if (!blob) return;

  if (window?.ReactNativeWebView?.postMessage) {
    const dataUrl = await blobToDataUrl(blob);
    const filename = explicitFilename ?? createDocumentFileName({ documentType, laudoId, link: 'arquivo.pdf' });
    redirectTo(dataUrl, { action: 'downloadFile', documentType, filename, mimeType: blob.type || 'application/pdf' });
    return;
  }

  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = explicitFilename ?? createDocumentFileName({ documentType, laudoId, link: 'arquivo.pdf' });
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}
